import Flex from 'components/common/Flex';
import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import HalfDoughnutChart from '../HalfDoughnutChart';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import useToken from 'hooks/useToken';
import { useEffect } from 'react';
import { FaChartBar } from 'react-icons/fa';
import { useToast } from 'context/providers/ToastProvider';


const AvanceGraficoTrimestral = ({
    mes,
}) => {

    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();
    const [cargando, setCargando] = useState(true);
    const [variablesMetasControl, setVariablesMetasControl] = useState({});

    const ObtenerAvanceMetaTrimestral = async () => {
        setCargando(true);
        const response = await fetch("/api/home/ObtenerAvanceMetaTrimestral?date=" + mes, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch: ' + error);
                console.log('Hubo un problema con la peticion Fetch: ' + error.message);

            });

        if (response.ok) {
            console.log(response);
            const data = await response.json();
            if (data['table1'][0].iResponseType == 1) {
                //Tabla con datos de la meta trimestral que corresponde
                setVariablesMetasControl(data['table2'][0]); //un objeto con los datos
            }
            else {
                showErrorToast(data['table1'][0].vMessage);
            }
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setCargando(false);

    };

    useEffect(() => {
        ObtenerAvanceMetaTrimestral();
    }, [mes]);

    return (
        <Card className="h-md-100">
            <Card.Header className="pb-0">
                <h5 className="mb-0 mt-2">{variablesMetasControl.title}</h5>
                <div className="d-flex align-items-center gap-2 mt-3 mb-1">
                    <FaChartBar className="text-muted fs-3" />
                    <h3 className="lh-1 fs--1 mb-0">
                        {variablesMetasControl.trimestre}
                    </h3>
                </div>

            </Card.Header>
            <Card.Body as={Flex} justifyContent="between">
                <div>
                    {cargando ?
                        <Skeleton width={100} /> :
                        <h2 className="mb-1 text-success fw-normal lh-1 fs-2 ">                            
                        {variablesMetasControl.nItemsVendidosTrim} Items</h2>}
                    {cargando ?
                        <Skeleton width={100} /> :
                        <>
                            <h6 className="mb-1 mt-3 text-700 fw-normal lh-1 fs--1">
                                {variablesMetasControl.dPorcentajeAvance}</h6>
                           
                        </>
                    }
                </div>
                <div>
                    <div className="my-n5">
                        {cargando ?
                            <Skeleton circle width={100} height={100} className="mb-1" />
                            :
                            <HalfDoughnutChart
                                color="primary"
                                target={variablesMetasControl.dMetaTrimestralItems}
                                reached={variablesMetasControl.nItemsVendidosTrim}
                            />
                        }
                    </div>
                    <p className="mb-0 mt-4 text-center fs--2 text-500">
                        Target:  {cargando ?
                            <Skeleton /> : <span className="text-800"> {variablesMetasControl.dMetaTrimestralItems} </span>}
                    </p>
                </div>
            </Card.Body>
        </Card>
    );
};

AvanceGraficoTrimestral.propTypes = {
    mes: PropTypes.instanceOf(Date),
};


export default AvanceGraficoTrimestral;
